import React, { useEffect, useState } from "react";
import "./Library.css";
import DynamicBanner from "../../include/DynamicBanner";
import api from "../../../../api";
import StickyNav from "./Partials/StickyNav";
import LatestNewsMarquee from "./Partials/LatestNewsMarquee";

const Eresources = () => {
  const [data, setData] = useState(null);

  const [bannerTitle, setBannerTitle] = useState("");
  const [bannerImagesDesktop, setBannerImagesDesktop] = useState([]);
  const [bannerImagesMobile, setBannerImagesMobile] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await api.get("/api/sitepages/about-us/libraryeresources");
        const apiData = response.data;

        const banner = apiData.banner_data;

        if (banner) {
          setBannerTitle(banner.title || "");
          setBannerImagesDesktop(banner.desktop_images || []);
          setBannerImagesMobile(banner.mobile_images || []);
        }

        setData(apiData);

      } catch (err) {
        console.error("Error fetching eresources:", err);
      }
    };

    fetchData();
  }, []);

  if (!data) return null;

  const mainSection = data.groups?.[0]?.main_section;
  if (!mainSection) return null;

  const { title, eresources_section } = mainSection;
  const sections = eresources_section?.sections || [];

  const journalSection = sections.find((s) => s.type === "journals");
  const journalList = journalSection?.content || [];

  /* -----------------------------------------------------
     RENDER CONTENT — LIST FORMAT UPDATED EXACTLY AS YOU WANT
  -------------------------------------------------------- */
  const renderContent = (section) => {
    if (section.type === "content") {
      return (
        <>
          {section.content.link && (
            <p>
              <strong>{section.title}: </strong>
              <a href={section.content.link.url} target="_blank" rel="noopener noreferrer">
                <span className="text-primary">{section.content.link.text}</span>
              </a>
              {section.content.link.info && <strong> {section.content.link.info}</strong>}
            </p>
          )}

          {section.content.description && <p>{section.content.description}</p>}

          {/* FEATURES LIST UPDATED */}
          {section.content.features && (
            <ul className="list-ul">
              {section.content.features.map((item, idx) => (
                <li key={idx}>
           
                    <i className="fa fa-dot-circle-o"></i>
               
                  {item}
                </li>
              ))}
            </ul>
          )}
        </>
      );
    }

    if (section.type === "journals") {
      return (
        <ul className="list-ul">
          {journalList.map((journal, idx) => (
            <li key={idx}>
            
                <i className="fa fa-dot-circle-o"></i>
           
              <a href={journal.url} target="_blank" rel="noopener noreferrer">
                {journal.name}
              </a>
            </li>
          ))}
        </ul>
      );
    }

    return null;
  };

  return (
    <section className="library-page pb_80">
      {(bannerImagesDesktop.length > 0 || bannerImagesMobile.length > 0) && (
        <DynamicBanner
          title={bannerTitle}
          bgImage={bannerImagesDesktop}
          bgImageMobile={bannerImagesMobile}
        />
      )}

      <LatestNewsMarquee />
      <StickyNav />

      {/* DESKTOP VIEW */}
      <div className="d-md-block d-none pb_80">
        <div className="container">
          <div className="sec-title text-center">
            <h2>{title}</h2>
          </div>

          <div className="nss-container tab-library-style">

            {/* LEFT TABS */}
            <div className="sidebar">
              <div className="nav flex-column nav-pills">
                {sections.map((sec, index) => (
                  <a
                    key={sec.id}
                    className={`nav-link ${index === 0 ? "active" : ""}`}
                    data-bs-toggle="pill"
                    href={`#${sec.id}`}
                  >
                    {sec.title}
                  </a>
                ))}
              </div>
            </div>

            {/* RIGHT CONTENT */}
            <div className="content-area">
              <div className="tab-content">
                {sections.map((sec, index) => (
                  <div
                    key={sec.id}
                    id={sec.id}
                    className={`tab-pane tab-css fade ${index === 0 ? "show active" : ""}`}
                  >
                    <h3>{sec.title}</h3>
                    {renderContent(sec)}
                  </div>
                ))}
              </div>
            </div>

          </div>
        </div>
      </div>

      {/* MOBILE VIEW */}
      <div className="pb_80 d-block d-md-none">
        <div className="container">
          <div className="sec-title text-center">
            <h2>{title}</h2>
          </div>

          <div className="accordion" id="eresourcesAccordion">
            {sections.map((sec, index) => (
              <div key={sec.id} className="accordion-item">
                <h2 className="accordion-header" id={`head-${sec.id}`}>
                  <button
                    className={`accordion-button ${index !== 0 ? "collapsed" : ""}`}
                    data-bs-toggle="collapse"
                    data-bs-target={`#col-${sec.id}`}
                  >
                    {sec.title}
                  </button>
                </h2>

                <div
                  id={`col-${sec.id}`}
                  className={`accordion-collapse collapse ${index === 0 ? "show" : ""}`}
                  data-bs-parent="#eresourcesAccordion"
                >
                  <div className="accordion-body">
                    {renderContent(sec)}
                  </div>
                </div>

              </div>
            ))}
          </div>
        </div>
      </div>

    </section>
  );
};

export default Eresources;
